export default __webpack_public_path__ + "static/blogprofile2-7e26b55a17f36aca32836b954f843ffd.png";